import React, { useMemo } from "react";
import styles from "./NotFoundPage.module.scss";
import classNames from "classnames/bind";
import Button from "../../components/ui/Button/Button";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import defaultMenuData from "../../data/menuItems.json";

const cx = classNames.bind(styles);

const NotFoundPage = () => {
  const { currentLanguage, translations } = useLanguageStore();

  const currentTranslations = useMemo(() => {
    return translations[currentLanguage] || defaultMenuData.content;
  }, [translations, currentLanguage]);

  return (
    <div className={cx("not-found")}>
      <div className={cx("not-found__container")}>
        <div className={cx("not-found__content")}>
          <div className={cx("not-found__error-code")}>
            <span className={cx("error-number")}>4</span>
            <div className={cx("error-jewelry")}>
              <div className={cx("jewelry-ring")}></div>
            </div>
            <span className={cx("error-number")}>4</span>
          </div>

          <div className={cx("not-found__text")}>
            <h1 className={cx("not-found__title")}>
              {currentTranslations?.NotFound?.title || "Oops! Page Not Found"}
            </h1>
            <p className={cx("not-found__subtitle")}>
              {currentTranslations?.NotFound?.subtitle || 
                "The page you're looking for seems to have vanished like a precious gem."}
            </p>
            <p className={cx("not-found__description")}>
              {currentTranslations?.NotFound?.description || 
                "Don't worry, our collection of beautiful jewelry is still here waiting for you. Let's help you find what you're looking for."}
            </p>
          </div>

          <div className={cx("not-found__suggestions")}>
            <h3 className={cx("suggestions-title")}>
              {currentTranslations?.NotFound?.suggestions_title || "What would you like to do?"}
            </h3>
            <div className={cx("suggestions-grid")}>
              <div className={cx("suggestion-item")}>
                <div className={cx("suggestion-icon")}>💍</div>
                <h4>{currentTranslations?.NotFound?.browse_rings || "Browse Rings"}</h4>
                <p>{currentTranslations?.NotFound?.rings_desc || "Discover our elegant ring collection"}</p>
                <Button
                  content={currentTranslations?.Button?.view_rings || "View Rings"}
                  second={true}
                  to="/products/category/Rings"
                  className={cx("suggestion-btn")}
                />
              </div>
              
              <div className={cx("suggestion-item")}>
                <div className={cx("suggestion-icon")}>📿</div>
                <h4>{currentTranslations?.NotFound?.browse_necklaces || "Browse Necklaces"}</h4>
                <p>{currentTranslations?.NotFound?.necklaces_desc || "Explore our stunning necklace designs"}</p>
                <Button
                  content={currentTranslations?.Button?.view_necklaces || "View Necklaces"}
                  second={true}
                  to="/products/category/Necklaces"
                  className={cx("suggestion-btn")}
                />
              </div>
              
              <div className={cx("suggestion-item")}>
                <div className={cx("suggestion-icon")}>💎</div>
                <h4>{currentTranslations?.NotFound?.browse_earrings || "Browse Earrings"}</h4>
                <p>{currentTranslations?.NotFound?.earrings_desc || "Find the perfect pair of earrings"}</p>
                <Button
                  content={currentTranslations?.Button?.view_earrings || "View Earrings"}
                  second={true}
                  to="/products/category/Earrings"
                  className={cx("suggestion-btn")}
                />
              </div>
            </div>
          </div>


        
        </div>

        <div className={cx("not-found__decorative")}>
          <div className={cx("floating-gem", "gem-1")}></div>
          <div className={cx("floating-gem", "gem-2")}></div>
          <div className={cx("floating-gem", "gem-3")}></div>
          <div className={cx("floating-gem", "gem-4")}></div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
